import { render, staticRenderFns } from "./AdminAlertPrefixList.vue?vue&type=template&id=9c374084"
import script from "./AdminAlertPrefixList.vue?vue&type=script&lang=js"
export * from "./AdminAlertPrefixList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports